/*
|--------------------------------------------------------------------------
| Template Helpers
|--------------------------------------------------------------------------
| 
*/

define('helpers',[
    'modernizr',
    'lodash',

    // block templates
    'text!templates/blocks/rightTri.html',
    'text!templates/blocks/parallel.html',
    'text!templates/blocks/parallels.html',
    'text!templates/blocks/digit.html',
    'text!templates/blocks/rightTriClip.html',
    'text!templates/blocks/imgSvg.html',
    'text!templates/blocks/svgFilters.html'
], function (Modernizr, _) {

    "use strict";

    var helpers = {};

    helpers.blocks = {
        rightTri:       _.template(arguments[2]),
        parallel:       _.template(arguments[3]),
        parallels:      _.template(arguments[4]),
        digit:          _.template(arguments[5]),
        rightTriClip:   _.template(arguments[6]),
        imgSvg:         _.template(arguments[7]),
        svgFilters:     _.template(arguments[8])
    };

    var deferImgTmpl = _.template(
        '<div class="defer-img<%= classNames %>">' +
            '<img onload="this.className = \'loaded\';" src="<%= src %>">' +
            '<div style="padding-bottom: <%= height %>%;"></div>' +
        '</div>'
    );

    var deferBkImgTmpl = _.template(
        '<div class="defer-bk-img<%= classNames %>">' +
            '<div class="loading"></div>' +
            '<img src="<%= src %>" onload="' +
                'this.parentElement.style.backgroundImage = \'url(\\\'<%= src %>\\\')\'; ' +
                'this.parentNode.innerHTML = \'\';">' +
        '</div>'
    );

    var draw = function (array) {
        return array[Math.floor(Math.random()*array.length)];
    };

    var cached = {
        images: []
    };

    function preload (src) {
        if (cached.images.indexOf(src) === -1) {
            cached.images.push(src);
            var img = new Image();
            img.src = src;
        }
    }

    /**
     * TODO: onload attribute reliablility
     */
    helpers.deferImg = function(src, aspectRatio, className) {
        src = this.route(src);
        preload(src);

        var AR = aspectRatio.split(':'),
            params = {
            src: src,
            classNames: className ? ' ' + className : '',
            height: AR[1] * 100 / AR[0]
        };

        return deferImgTmpl(params);
    };

    helpers.deferBkImg = function (src, className) {
        src = this.route(src);
        preload(src);

        return deferBkImgTmpl({
            src: src,
            classNames: className ? ' ' + className : ''
        });
    };

    helpers.asset = function (fragment) {
        var url = this.route(fragment);

        // svg fallback
        if (!Modernizr.svg && /\.svg$/i.test(url)) {
            url.replace(/\.svg$/, '.png').replace(/\/img\//, '/img/png/');
        }

        return url;
    };

    helpers.route = function (fragment) {
        // default
        if (!fragment) {
            return this.siteURL;
        }

        // external links
        if (fragment.match(/^http/)) {
            return fragment;
        }

        // remove root slash
        fragment = fragment.replace(/^\//, '');

        return !/^http/.test(fragment) ? this.siteURL + '/' + fragment : fragment;
    };

    helpers.limit = function (str, limit, end) {
        return str.length >limit ? str.slice(0, limit) + (end === undefined ? '...' : end) : str;
    };

    helpers.kebabCase = function (str) {
        return str.replace(/_|([A-Z])| /g, function (v) {
            return '-' + v.replace(/_| /, '').toLowerCase();
        });
    };

    helpers.capitialize = function (str) {
        return str.replace(/^[a-z]|(_|-)[a-zA-Z]|[a-z][A-Z]| [a-z]/g, function (v) {
            return (v.length > 1 && v[0].match(/[a-zA-Z]/) ? v[0] : '') + ' ' + v.slice(-1).toUpperCase();
        });
    };

    helpers.randomHighlight = function (str, classNames, chance) {
        var arr = [],
            inTag = false;
        _.each(str.split(''), function (character) {
            var classN = classNames instanceof Array ? draw(classNames) : classNames;
            if (character === '<') {
                inTag = true;
            }
            if (!inTag && character.match(/\w/) && (Math.random() < chance)) {
                character = '<span class="' + classN + '">' + character + '</span>';
            }
            if(character === '>') {
                inTag = false;
            }

            arr.push(character);
        });
        return arr.join('');
    };

    helpers._ = _;

    return helpers;

});
